module.exports = __webpack_public_path__ + "assets/chat-tab.2f674c3d.svg";